module.exports = __webpack_public_path__ + "static/media/B18.80ce5b21.jpg";